import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useWorkAuthorizationCountries, useUpdate: useUpdateWorkAuthorizationCountries } =
  getCRUDHooks({
    entityName: 'workAuthorizationCountries',
    get: ({ userId }) =>
      clientApi.getOCClient().helpers.user.users.id(userId).workAuthorizationCountries.find(),
    update: (values, { userId, context }) =>
      clientApi
        .getOCClient()
        .helpers.user.users.id(userId)
        .workAuthorizationCountries.update('', values, false)
        .setHeader('X-Request-Context', context)
        .execute(),
  });

export { useWorkAuthorizationCountries, useUpdateWorkAuthorizationCountries };
